<script setup lang="ts">
import {ref} from "vue"
import getCast from "../../../lib/chromecast";

// const props = defineProps<{
//
// }>()

const time = ref("--:--")
const duration = ref("--:--")
const seeker = ref(null)
const pbState = ref("buffering")
const seekerMin = ref(0)
const seekerMax = ref(100)
const seekerVal = ref(0)
const seekerStyle = ref('0% 100%')

const castOpts = {}
// if (contentItem.tags.includes("dev")){
//     castOpts["receiver"] = '159A62D0'
// }
const cast = getCast(castOpts);

cast.on("time", (e) => {
    time.value = e?.detail?.timePretty
    if (e?.detail?.duration === -1){
        duration.value = "LIVE";
        seekerMin.value = e.detail.range.start;
        seekerMax.value = e.detail.range.end;
        seekerVal.value = Math.round(e.detail.time);
        // (seeker.value as HTMLElement).setAttribute("min", e.detail.range.start);
        // (seeker.value as HTMLElement).setAttribute("max", e.detail.range.end);
        // (seeker.value as HTMLElement).value = e.detail.time;
        let progress = (e.detail.time - e.detail.range.start) * 100 / (e.detail.range.end - e.detail.range.start);
        seekerStyle.value = Math.round(progress) + '% 100%';
        // (seeker.value as HTMLElement).style.backgroundSize = progress + '% 100%';
        // console.log(seekerStyle.value, seekerMin.value, seekerMax.value, seekerVal.value, e.detail)
    }else{
        duration.value = e.detail.durationPretty;
        seekerVal.value = Math.round(e.detail.progress);
        seekerStyle.value = Math.round(e.detail.progress) + '% 100%';
        // (seeker.value as HTMLElement).value = e.detail.progress;
        // (seeker.value as HTMLElement).style.backgroundSize = (seeker.value as HTMLElement).value + '% 100%';
        // console.log((seeker.value as HTMLElement).value, e.detail.progress)
    }
})

cast.on('statechanged', (e) => {
    if (['playing', "pause", "buffering"].indexOf(e?.detail?.value) !== -1) {
        pbState.value = e.detail.value
    }
})

const disconnect = () => {
    cast.disconnect()
}

const rewind = () => {
    cast.rewind(10)
}

const playPause = () => {
    if (cast.paused){
        cast.play()
    }else{
        cast.pause()
    }
}

const volue = (e) => {
    let target = e.target
    target.style.backgroundSize = (target.value - target.min) * 100 / (target.max - target.min) + '% 100%';
    cast.volume(parseFloat(target.value));
}

const seek = (e) => {
    let target = e.target

    if (cast.duration === -1){
        target.style.backgroundSize = (target.value - target.min) * 100 / (target.max - target.min) + '% 100%';
        cast.seek(parseInt(target.value));
    }else{
        target.style.backgroundSize = target.value + '% 100%';
        cast.seek(parseInt(target.value), true);
    }
}
</script>

<template>
    <div class="cast-controls">
        <div class="media-info">
            <div class="media-title"></div>
        </div>
        <div class="castig-to-info"></div>
        <div class="media-controls">

            <div class="media-btns flex justify-center">
                <div class="media-btn-p" :class="{
                    'ft-state-buffering': pbState === 'buffering',
                    'ft-state-playing': pbState === 'playing',
                    'ft-state-paused': pbState === 'pause',
                }" role="button" tabindex="0" aria-label="Play" @click="playPause">
                    <svg xmlns="http://www.w3.org/2000/svg" class="jw-svg-icon jw-svg-icon-buffer rotate" viewBox="0 0 240 240" focusable="false" fill="currentColor">
                        <path d="M120,186.667a66.667,66.667,0,0,1,0-133.333V40a80,80,0,1,0,80,80H186.667A66.846,66.846,0,0,1,120,186.667Z"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" class="jw-svg-icon jw-svg-icon-play" viewBox="0 0 240 240" focusable="false" fill="currentColor">
                        <path d="M62.8,199.5c-1,0.8-2.4,0.6-3.3-0.4c-0.4-0.5-0.6-1.1-0.5-1.8V42.6c-0.2-1.3,0.7-2.4,1.9-2.6c0.7-0.1,1.3,0.1,1.9,0.4l154.7,77.7c2.1,1.1,2.1,2.8,0,3.8L62.8,199.5z"></path>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" class="jw-svg-icon jw-svg-icon-pause" viewBox="0 0 240 240" focusable="false" fill="currentColor">
                        <path d="M100,194.9c0.2,2.6-1.8,4.8-4.4,5c-0.2,0-0.4,0-0.6,0H65c-2.6,0.2-4.8-1.8-5-4.4c0-0.2,0-0.4,0-0.6V45c-0.2-2.6,1.8-4.8,4.4-5c0.2,0,0.4,0,0.6,0h30c2.6-0.2,4.8,1.8,5,4.4c0,0.2,0,0.4,0,0.6V194.9z M180,45.1c0.2-2.6-1.8-4.8-4.4-5c-0.2,0-0.4,0-0.6,0h-30c-2.6-0.2-4.8,1.8-5,4.4c0,0.2,0,0.4,0,0.6V195c-0.2,2.6,1.8,4.8,4.4,5c0.2,0,0.4,0,0.6,0h30c2.6,0.2,4.8-1.8,5-4.4c0-0.2,0-0.4,0-0.6V45.1z"></path>
                    </svg>
                </div>
            </div>
        </div>
        <div class="controls-bar">
            <div class="media-progress">
                <input :min=seekerMin :max=seekerMax :value="seekerVal" type="range" :style="{backgroundSize: seekerStyle}" class="custom-range block w-full" ref="seeker" id="player-seek-control" @input="seek">
            </div>
            <div class="cast-data">
                <div class="cast-data-left">
                    <div class="revers-control-area media-rewind" role="button" @click="rewind">
                        <svg xmlns="http://www.w3.org/2000/svg" class="revers-control" viewBox="0 0 20 16.69">
                            <defs></defs>
                            <path d="M3,17.18V11.24H1.63V10.15a2.2,2.2,0,0,0,1.06-.42,2.15,2.15,0,0,0,.74-.86H4.51v8.31Z" transform="translate(0 -0.62)"/>
                            <path d="M10.8,14.85a2.34,2.34,0,0,1-.72,1.74,2.47,2.47,0,0,1-3.49,0,2.37,2.37,0,0,1-.72-1.74V11.2A2.39,2.39,0,0,1,6.6,9.45a2.36,2.36,0,0,1,1.74-.71,2.34,2.34,0,0,1,1.74.72,2.37,2.37,0,0,1,.72,1.74ZM9.19,11.17a.86.86,0,0,0-.26-.63.87.87,0,0,0-.64-.27.85.85,0,0,0-.63.27.86.86,0,0,0-.26.63v3.66a.89.89,0,0,0,.26.63.88.88,0,0,0,.63.26.89.89,0,0,0,.9-.89Z" transform="translate(0 -0.62)"/>
                            <path d="M18,3H3.64V1.07A.45.45,0,0,0,2.88.75L.13,3.5a.45.45,0,0,0,0,.63L2.88,6.87a.44.44,0,0,0,.76-.31V4.62H18.35V15.28H12.5V17H18A2,2,0,0,0,20,15V5A2.05,2.05,0,0,0,18,3Z" transform="translate(0 -0.62)"/>
                        </svg>
                    </div>
                    <div class="media-time-data">
                        <div class="media-time">{{ time }}</div> / <div class="media-duration">{{ duration }}</div>
                    </div>
                    <div class="media-volume-block" role="button">
                        <div class="volume-control state-sound-on">
                            <svg xmlns="http://www.w3.org/2000/svg" class="sound-on" viewBox="0 0 20 18.98">
                                <path d="M11.43.69c0-.17-.11-.23-.24-.13L3.84,6a1,1,0,0,1-.56.19h-3a.31.31,0,0,0-.31.3v7.06a.31.31,0,0,0,.31.3h3a1,1,0,0,1,.56.19l7.35,5.42c.13.1.24,0,.24-.13Z" transform="translate(0 -0.51)"/>
                                <path d="M14.59,18.65a.92.92,0,0,1-.46-1.72,8,8,0,0,0,0-13.86A.92.92,0,0,1,15,1.47a9.81,9.81,0,0,1,0,17.06A.92.92,0,0,1,14.59,18.65Z" transform="translate(0 -0.51)"/>
                                <path d="M14.58,13.91a.91.91,0,0,1-.67-.3.92.92,0,0,1,.05-1.3,3.17,3.17,0,0,0,0-4.62.92.92,0,1,1,1.25-1.35,5,5,0,0,1,0,7.32A.93.93,0,0,1,14.58,13.91Z" transform="translate(0 -0.51)"/>
                            </svg>
                            <svg xmlns="http://www.w3.org/2000/svg" class="sound-off" viewBox="0 0 18.93 18.98">
                                <path d="M11.43.69c0-.17-.11-.23-.24-.13L3.84,6a1,1,0,0,1-.56.19h-3a.31.31,0,0,0-.31.3v7.06a.31.31,0,0,0,.31.3h3a1,1,0,0,1,.56.19l7.35,5.42c.13.1.24,0,.24-.13Z" transform="translate(0 -0.51)"/>
                                <path d="M17.29,10l1.37-1.37a.92.92,0,0,0-1.3-1.3L16,8.7,14.62,7.33a.92.92,0,1,0-1.3,1.3L14.69,10l-1.37,1.37A.92.92,0,0,0,14,12.94a.91.91,0,0,0,.65-.27L16,11.3l1.37,1.37a.92.92,0,0,0,.65.27.91.91,0,0,0,.65-.27.92.92,0,0,0,0-1.3Z" transform="translate(0 -0.51)"/>
                            </svg>
                        </div>
                        <div class="media-volume" role="button">
                            <input min="0" max="1" step="0.1" value="1" type="range" class="custom-range block w-full" id="player-volume-control" @input="volue">
                        </div>
                    </div>
                </div>
                <div class="cast-data-right">
                    <div class="chromecast-control-area" role="button" @click="disconnect">
                        <svg class="chromecast-stop" viewBox="0 0 20 16.4">
                            <path d="M0,8.08v2a8.16,8.16,0,0,1,5.78,2.4,8.14,8.14,0,0,1,2.4,5.76h2A10.16,10.16,0,0,0,0,8.08Z" transform="translate(0 -1.8)"/>
                            <path d="M0,8.08v2a8.16,8.16,0,0,1,5.78,2.4,8.14,8.14,0,0,1,2.4,5.76h2A10.16,10.16,0,0,0,0,8.08Z" transform="translate(0 -1.8)"/>
                            <path d="M0,11.67v2A4.62,4.62,0,0,1,3.21,15,4.62,4.62,0,0,1,4.57,18.2h2A6.63,6.63,0,0,0,0,11.67Z" transform="translate(0 -1.8)"/>
                            <path d="M0,15.36V18.2H2.76v0A2.79,2.79,0,0,0,0,15.36Z" transform="translate(0 -1.8)"/>
                            <path d="M3.68,6.7c.34.11.69.24,1,.38A12,12,0,0,1,8.54,9.67a11.9,11.9,0,0,1,2.59,3.83c.14.32.26.65.37,1h4.86v-9H3.68Z" transform="translate(0 -1.8)"/>
                            <path d="M17.91,1.8H2.09A2.1,2.1,0,0,0,0,3.89V6.13H0a12.22,12.22,0,0,1,1.72.12V3.48h16.6v13H12a11.36,11.36,0,0,1,.13,1.75h5.82A2.1,2.1,0,0,0,20,16.11V3.89A2.1,2.1,0,0,0,17.91,1.8Z" transform="translate(0 -1.8)"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
